import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  time: {
    fontSize: '13px',
    display: 'block',
    paddingTop: '17px',
    paddingRight: '13px',
    color: '#7a7f83',
  },
  timeHighlighted: {
    color: '#383f45',
    fontWeight: 500,
  },
  dot: {
    display: 'block',
    width: '10px',
    height: '10px',
    borderRadius: '5px',
    backgroundColor: '#1b76ed',
    marginTop: '8px',
    position: 'absolute',
    right: '20px',
  },
};

const ConversationTime = ({ time, isNew, style }) => (
  <span style={style}>
    <span style={{ ...styles.time, ...isNew && styles.timeHighlighted }}>{time}</span>
    {isNew && <span style={styles.dot} />}
  </span>
);

ConversationTime.propTypes = {
  time: PropTypes.string.isRequired,
  isNew: PropTypes.bool,
  style: PropTypes.shape({}),
};

export default ConversationTime;



// WEBPACK FOOTER //
// ./src/views/chat/components/ConversationTime.js